import { useTranslation } from 'react-i18next';
import { StorageData } from '../../models/rate.types';
import { formatCurrencyAmount, useCurrency } from '@modules/Orders/shared/hooks/useCurrency';

interface StorageDataDisplayProps {
  data: StorageData;
}

export const StorageDataDisplay = ({ data }: StorageDataDisplayProps) => {
  const { t } = useTranslation('ratesModule');
  const currency = useCurrency();

  return (
    <div className="border border-card-border rounded-lg overflow-hidden">
      <div className="bg-card-border/30 px-4 py-2 border-b border-card-border">
        <p className="font-medium text-title text-sm">{t('itemData.storage.fixedFee')}</p>
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between">
          <span className="text-xs text-subtext">{t('itemData.storage.monthlyFee', 'Tarifa mensual')}</span>
          <span className="text-lg font-semibold text-title">{formatCurrencyAmount(data.fixed_fee, currency)}</span>
        </div>
      </div>
    </div>
  );
};
